import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        accountTitle: {
            textStyle: 'head-large',
            marginTop: remCalc(12),
            paddingBottom: {base: 0, sm: remCalc(24), md: 0},
            paddingY: {base: 0, lg: remCalc(12)},
            paddingTop: {base: remCalc(16), lg: remCalc(24)},
            fontWeight: 'medium',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        accountTitleDetails: {
            textStyle: 'head-large',
            fontWeight: 'medium',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            marginTop: remCalc(24),
            paddingBottom: remCalc(24),
        },
        accountTitleDetailsSubscriptionCancel: {
            textStyle: 'head-xlarge',
            fontWeight: 'medium',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            marginTop: remCalc(24),
            paddingBottom: remCalc(24),
        },
        subscriptionGap: {
            gap: {base: remCalc(24), lg: remCalc(40)},
        },
        subscriptionCancelGap: {
            marginTop: {base: remCalc(24), lg: remCalc(40)},
            gap: '16px',
        },
        assistanceContainer: {
            display: 'flex',
            flexDir: 'column',
            backgroundColor: 'background.light',
            padding: remCalc(24),
            borderRadius: 'large.lg',
            gap: {base: remCalc(16), md: remCalc(24)},
        },
        assistanceButton: {
            maxWidth: remCalc(332),
        },
        assistanceTitle: {
            textStyle: 'head-xsmall',
            color: 'text.default',
            fontWeight: 'medium',
            lineHeight: 'head-xsmall',
        },
        assistanceDescription: {
            textStyle: 'body-small',
            color: 'text.default',
        },
        subscriptionNumberHeader: {
            textStyle: 'head-medium',
            color: 'text.default',
            fontWeight: 'medium',
            paddingY: remCalc(16),
            wordBreak: 'break-word',
        },
        subscriptionBoxContainer: {
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            borderRadius: 'large.lg',
            display: 'flex',
            flexDir: 'column',
            padding: remCalc(24),
        },
        subscriptionCancelBoxContainer: {
            display: 'flex',
            flexDir: 'column',
            //padding: remCalc(24),
        },
        itemCode: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
            fontWeight: 'normal',
            marginBottom: remCalc(12),
        },
        subscriptionBoxUpContainer: {
            columns: {base: 1, md: 4},
            gap: remCalc(24),
            w: '100%',
        },
        subscriptionBoxLabel: {
            fontWeight: 'bold',
        },
        subscriptionInnerBoxContainer: {
            w: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(16),
        },
        subscriptionStatusDetailsContainer: {
            display: 'flex',
            w: '100%',
        },
        subscriptionStatusContainer: {
            w: '100%',
        },
        subscriptionDetailsLabelContainer: {
            w: remCalc(60),
            paddingTop: remCalc(38),
        },
        statusLabel: {
            justify: 'space-between',
            align: 'center',
            width: '100%',
            paddingTop: remCalc(16),
        },
        subscriptionDetailsLabel: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            textDecoration: 'underline',
            color: 'text.tertiary',
            cursor: 'pointer',
        },
        noSubscriptionsContainer: {
            gap: remCalc(16),
            alignItems: 'flex-start',
        },
        noSubscriptionsTitle: {
            color: 'text.default',
            fontWeight: 'medium',
            textStyle: 'head-medium',
        },
        noSubscriptionsDescription: {
            color: 'text.default',
            textStyle: 'body-medium',
        },
        subscriptionBoxBottomContainer: {
            mt: remCalc(24),
        },
        selectOrderContainer: {
            display: 'flex',
            flexDirection: {base: 'column', md: 'row'},
            mt: remCalc(24),
        },
        selectOrderSelect: {
            w: '100%',
            maxW: {base: 'unset', md: remCalc(332)},
        },
        selectOrderButton: {
            ml: {base: remCalc(0), md: remCalc(24)},
            mt: {base: remCalc(24), md: remCalc(0)},
            px: remCalc(50),
        },
        subscriptionDetailsList: {
            listStyleType: 'none',
            ml: 0,
        },
        modalCloseIcon: {boxSize: {base: 'iconsSize.medium'}},
        infoContainer: {
            paddingTop: remCalc(12),
        },
        infoNameContainer: {
            flexDirection: 'column',
            marginBottom: remCalc(8),
        },
        infoExpirationContainer: {
            flexDirection: 'column',
        },
        infoLabel: {
            color: 'text.secondary',
            textStyle: ['body-medium'],
        },
        infoValue: {
            textStyle: ['body-medium'],
        },
        cancelSubscriptionSelectContainer: {
            pt: [0, 0, 0, remCalc(24)],
            mb: [remCalc(16), remCalc(16), remCalc(16), 0],
        },
        cancelSubscriptionSelect: {
            width: ['100%', '100%', '100%', '100%', remCalc(390)],
            fontSize: remCalc(12),
        },
        subscriptionEditHeaderContent: {
            textStyle: 'body-large',
            fontWeight: 'normal',
            paddingTop: 0,
            paddingRight: 0,
            paddingLeft: 0,
            borderBottom: '1px solid',
            borderColor: 'border.dark',
        },
        subscriptionEditBodyContent: {
            paddingLeft: '0px',
            paddingRight: '0px',
            paddingTop: '24px',
        },
        subscriptionEditRadio: {
            border: '1px solid',
            borderColor: 'border.dark',
            _hover: {
                bg: 'none',
                borderColor: 'border.dark',
                color: 'text.primary',
            },
            _checked: {
                bg: 'none',
                borderColor: 'border.dark',
                color: 'text.primary',
                '&::before': {
                    content: '""',
                    display: 'inline-block',
                    position: 'relative',
                    width: '50%',
                    height: '50%',
                    borderRadius: '50%',
                    background: 'border.dark',
                },
            },
            _focus: {
                boxShadow: 'none !important',
            },
        },
        addButton: {
            width: {base: '100%', lg: remCalc(332)},
        },
        paymentModifyCardTile: {
            border: '1px solid',
            borderColor: 'border.dark',
            borderRadius: 'md',
            padding: `${remCalc(24)} ${remCalc(20)} ${remCalc(20)} ${remCalc(20)}`,
            gap: remCalc(20),
            w: '100%',
            cursor: 'pointer',
            _checked: {
                borderColor: 'border.dark',
            },
        },
        paymentModifyIconAndEndsWith: {
            paddingY: remCalc(16),
        },
        paymentModifyOuterStack: {
            alignItems: 'flex-start',
            gap: remCalc(0),
        },
        paymentModifyInnerStack: {
            gap: remCalc(4),
            alignItems: 'flex-start',
        },
    },
}
